import {Brick, registerBrick, ErrorFlow} from 'olympe';
import {PurchaseRequest} from '../../models/PurchaseRequest';
import {tagToDisplayER} from '../tagTransforms';

export default class GetEPRID extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRJSON
     * @param {function(string)} setEPRID
     * @param {function(*)} setErrorFlow
     */
    update($, [prJSON, prTag], [setEPRID, setErrorFlow]) {
        let eprId = '';

        try {
            if (prJSON) {
                eprId = new PurchaseRequest(prJSON).EPRId;
            }

            setEPRID(eprId || tagToDisplayER(prTag));
        } catch (e) {
            setErrorFlow(ErrorFlow.create('Cannot read EPR ID', 2073));
        }
    }
}

registerBrick('0192e3548be9e5492af5', GetEPRID);
